function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MassValue = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _reactI18next = require("react-i18next");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var MassValue = exports.MassValue = (0, _react.memo)(function (_ref) {
  var children = _ref.children,
    value = _ref.value,
    _ref$unit = _ref.unit,
    unit = _ref$unit === void 0 ? 'kg' : _ref$unit,
    containerStyle = _ref.containerStyle,
    valueStyle = _ref.valueStyle,
    unitStyle = _ref.unitStyle;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  return (0, _jsxRuntime.jsxs)(_reactNative.Text, {
    textBreakStrategy: "simple",
    style: [styles.valueContainer, containerStyle],
    children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
      textBreakStrategy: "simple",
      style: [styles.value, valueStyle],
      children: (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [value && t('format:number', {
          value: value
        }), children]
      })
    }), (0, _jsxRuntime.jsxs)(_reactNative.Text, {
      textBreakStrategy: "simple",
      style: [styles.unit, unitStyle],
      children: [' ', unit]
    })]
  });
});